import React, {useCallback, useState} from "react"
import {connect} from "react-redux"

import Popup from "../../../components/Popup"
import IntegrationWizard, {IntegrationWizardStep} from "../../../components/IntegrationWizard"
import notifyUser from "../../../methods/notifyUser"

import "pages/Styles/IntegrationsWizard.sass"

export const PARAPLAN_DOCS_URL =
    "https://paraplancrm.ru/knowledgebase/?category=electronic-document-management"

const STEPS: IntegrationWizardStep[] = [
    {
        id: "about",
        type: "info",
        title: "Что умеет интеграция",
        description: "Из Параплан CRM можно создать документ по шаблону ОкиДоки на данных ученика, отправить ссылку на подписание и сохранить подписанный PDF в системе.",
        list: [
            "Шаблоны создаются и правятся в ОкиДоки. Сначала подготовьте те, которыми будете пользоваться.",
            "Клиент подписывает на странице ОкиДоки, регистрироваться ему не нужно.",
            "Статус в Параплане обновляется сам. PDF остаётся в разделе «Документы», в профиле ученика и в личном кабинете, если он подключён.",
        ],
    },
    {
        id: "copy_api_key",
        type: "api_key_copy",
        title: "Скопируйте API-ключ",
        description: "Вставьте этот ключ в Параплан CRM:",
    },
    {
        id: "connect",
        type: "info",
        title: "Подключите ОкиДоки в Параплане",
        list: [
            "Настройки → Настройки компании → блок «Электронный документооборот».",
            "Вставьте API-ключ и сохраните. Статус станет «Подключено», шаблоны ОкиДоки появятся в Параплане.",
            "Нажмите «Настроить», выберите шаблон и сопоставьте поля карточки ученика с полями ОкиДоки. Для каждого шаблона настройка своя.",
            "Если поля шаблона изменились в ОкиДоки, откройте его в Параплане и нажмите «Обновить поля шаблона».",
            "Права сотрудникам: Настройки → Роли → блок «Документы» — просмотр, создание и скачивание PDF.",
        ],
    },
    {
        id: "docs",
        type: "external_link",
        title: "Инструкция Параплана",
        description: "В базе знаний — настройка ключа, автозаполнение, права ролей и создание документа.",
        linkUrl: PARAPLAN_DOCS_URL,
        ctaLabel: "Открыть инструкцию",
    },
    {
        id: "create_document",
        type: "info",
        title: "Создайте документ",
        list: [
            "Раздел «Документы» или вкладка «Документы» в профиле ученика → «Создать документ».",
            "Из профиля ученик уже выбран. Из общего раздела его нужно выбрать вручную.",
            "Выберите шаблон и исполнителя и подтвердите согласие на обработку персональных данных.",
            "Ссылку можно скопировать или отправить на email ученика из Параплана.",
        ],
    },
]

type Props = {
    close: Function,
    $store: any,
    $commitToStore: Function,
}

let ParaplanIntegrationPopup: any = function ParaplanIntegrationPopup(props: Props) {
    const [currentStepIndex, setCurrentStepIndex] = useState(0)
    const [completedStepIds, setCompletedStepIds] = useState<Set<string>>(new Set())

    const isStepComplete = useCallback(
        (stepId: string) => completedStepIds.has(stepId),
        [completedStepIds]
    )

    const completeStep = useCallback((stepId: string) => {
        setCompletedStepIds((prev) => {
            if (prev.has(stepId)) {
                return prev
            }
            const next = new Set(prev)
            next.add(stepId)
            return next
        })
    }, [])

    function onCopyApiKey() {
        notifyUser(props, "API-ключ скопирован. Вставьте его в Параплан: Настройки → Настройки компании → Электронный документооборот")
        completeStep("copy_api_key")
    }

    return (
        <Popup
            maxWidth="650px"
            onClose={() => props.close()}
        >
            <div className="realty-integration-setup ui-kit-v2">
                <div className="commonLabel ui-kit-v2 realty-integration-setup__title">
                    Интеграция с Параплан
                </div>
                <div className="commonSubtitle ui-kit-v2 realty-integration-setup__subtitle">
                    Документ из карточки ученика по шаблону ОкиДоки.
                </div>
                <IntegrationWizard
                    steps={STEPS}
                    currentStepIndex={currentStepIndex}
                    isStepComplete={isStepComplete}
                    onCompleteStep={completeStep}
                    onChangeStep={setCurrentStepIndex}
                    onFinish={() => props.close()}
                    context={{
                        apiKey: `${props.$store.userSession?.realty_api_key || ""}`,
                        onCopyApiKey,
                    }}
                />
            </div>
        </Popup>
    )
}

ParaplanIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(ParaplanIntegrationPopup)

export default ParaplanIntegrationPopup
